













































































import Vue from "vue";
import Api from "../../base/api.typings";
import Component from "vue-class-component";
import chamadoRecorrenteService from "./chamado-recorrente-service";
import chamadoService from "../chamado/chamado-service";
import routerService from '../../base/router-service';
import empresaAtualService from "../empresa-atual/empresa-atual-service";
import areaService from '../area-atual/area-service';
import funcionarioService from "../funcionario/funcionario-service";

@Component
export default class ChamadoRecorrenteListar extends Vue {
    chamados: Api.App.Server.ChamadoRecorrente.Listar.ResultadoDto = null;

    get carregando() {
        return !this.chamados;
    }

    tamanhoPagina: number = 8;

    paginaAtual: number = 1;

    dataAtual: any = null;

    areaAtual: string = null;

    empresaId: string = null;

    async alterarPagina(incremento: number) {
        this.paginaAtual += incremento;

        if (this.paginaAtual <= 1)
            this.paginaAtual = 1;

        await this.listarChamados();
    }

    async listarChamados() {
        let chamadosListados = await chamadoRecorrenteService.listar({
            tamanhoPagina: this.tamanhoPagina,
            paginaAtual: this.paginaAtual,
            empresaId: this.empresaId,
        });
        this.chamados = chamadosListados;
    }

    async cadastrarChamadoRecorrente() {
        if (this.areaAtual == 'admin' || this.areaAtual == 'empresa') {
            await chamadoService.cadastrarChamadoRecorrente({
            });
            await routerService.goTo('chamado-listar');
        }
    }

    async inserirChamadoRecorrente() {
        await routerService.goTo('chamado-recorrente-abrir');
    }

    obterPeriodoTipo(tipo: number) {
        switch (+tipo) {
            case Api.Common.Domain.PeriodoTipoEnum.Ano: {
                return "Ano";
            }

            case Api.Common.Domain.PeriodoTipoEnum.Dia: {
                return "Dia";
            }

            case Api.Common.Domain.PeriodoTipoEnum.Mes: {
                return "Mês";
            }

            case Api.Common.Domain.PeriodoTipoEnum.Semana: {
                return "Semana";
            }
        }
    }

    async excluirChamadoRecorrente(chamado: number) {
        if (this.areaAtual == 'admin' || this.areaAtual == 'empresa') {
            this.$action.processAction({
                action: async () => {
                    let excluir = await this.$confirm.open({
                        title: "Excluir",
                        message: "Deseja realmente excluir ?"
                    });
                    if (excluir) {
                        await chamadoRecorrenteService.excluir({
                            id: chamado,
                        })
                        await this.listarChamados();
                    }
                },
            });
        }
    }

    beforeRouteUpdate() {
        this.listarChamados();
    }

    async carregarDados() {
        this.empresaId = await empresaAtualService.obterEmpresaAtualId();
        if (this.empresaId) {
            this.listarFuncionarios();
            this.areaAtual = await areaService.obterAreaPadrao();
            if (this.areaAtual == 'admin' || this.areaAtual == 'empresa') {
                this.listarChamados();
            }
        }
    }

    created() {
        this.carregarDados();
    }


    async detalharChamado(chamado: Api.App.Server.Chamado.ListarChamados.Dto) {
        await routerService.goTo('chamado-recorrente-editar', { chamadoId: chamado.id });
    }

    funcionario: any[] = [];

    async listarFuncionarios() {
        let funcionario = await funcionarioService.listarPorEmpresa({
            empresaId: this.empresaId
        });

        let result = [];

        for (let item of funcionario.itens) {
            result.push({
                id: item.id,
                nome: item.nome
            })
        }

        this.funcionario = result;
    }

    obterNomeFuncionario(id: number) {
        if (!this.funcionario)
            return "";

        let usuario = this.funcionario.find(p => p.id == id);
        if (usuario) {
            return usuario.nome;
        }
    }
}
